import { Tooltip, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import packIcons from '../../packIcons.json';
import PackIcon from '../PackIcon';

const useStyles = makeStyles({
  theme: { marginTop: 8, marginBottom: 4, color: '#666' },
  grid: { display: 'flex', flexWrap: 'wrap', gap: 6 },
  cell: { width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #ddd', borderRadius: 6, background: '#fff', cursor: 'pointer', padding: 0, fontSize: 11, color: '#333' },
  selected: { border: '2px solid #00a3c4', background: '#e6f8fb' },
  none: { width: 'auto', padding: '0 10px' },
  current: { marginTop: 6 },
  warning: { color: '#c77700' },
});

const LISTED = new Set(packIcons.flatMap((group) => group.icons));

// redux-form field: a pack's icon (a MaterialCommunityIcons name, '' for none), chosen in the curated grid.
const ReduxFormIconPicker = ({ input: { value, onChange } }) => {
  const classes = useStyles();
  const cell = (name, content, extra) => (
    <Tooltip key={name || 'none'} title={name || 'Aucune'}>
      <button type="button" className={[classes.cell, value === name ? classes.selected : '', extra].join(' ')} onClick={() => onChange(name)} aria-pressed={value === name}>
        {content}
      </button>
    </Tooltip>
  );
  return (
    <div>
      <div className={classes.grid}>{cell('', 'Aucune', classes.none)}</div>
      {packIcons.map((group) => (
        <div key={group.theme}>
          <Typography variant="caption" component="div" className={classes.theme}>
            {group.theme}
          </Typography>
          <div className={classes.grid}>{group.icons.map((name) => cell(name, <PackIcon name={name} size={24} />))}</div>
        </div>
      ))}
      {value ? (
        <Typography variant="body2" className={classes.current}>
          {value} {!LISTED.has(value) && <span className={classes.warning}>(icône hors liste)</span>}
        </Typography>
      ) : null}
    </div>
  );
};

ReduxFormIconPicker.propTypes = {
  input: PropTypes.object.isRequired,
};

export default ReduxFormIconPicker;
